export default __webpack_public_path__ + "static/media/link-clicked-colored.24b08427.svg";